import * as React from "react";
const SvgArrowBody = (props) => /* @__PURE__ */ React.createElement("svg", { width: 204, height: 2, viewBox: "0 0 204 2", fill: "none", preserveAspectRatio: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.518066 1L203.426 0.999982", stroke: "#080808", strokeWidth: 2 }));
export default SvgArrowBody;
